import { Alert, Collapse } from 'antd'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CheckCircle, TimesCircle } from '$components/Icons'
import check_successful from '$assets/img/check_successful.png'
import { StyledCollapse, StyledTable } from '../styledComponents'
import createColumnsFeasible from './createColumnsFeasible'
import createColumnsNotFeasible from './createColumnsNotFeasible'
import { machbarkeitsPruefung } from './machbarkeitsPruefung'
import PropTypes from 'prop-types'

const { Panel } = Collapse

const StepOneSelection = (props) => {
  const {
    servicesData,
    bookedServiceStatus,
    selectedParts,
    setBookableParts,
    bookableParts,
    setConfigState,
  } = props
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [defaultActiveKey, setDefaultActiveKey] = useState(['1'])

  const onChange = (key) => {
    setDefaultActiveKey(key)
  }

  useEffect(() => {
    setLoading(true)

    const getMachbarkeit = async () => {
      if (servicesData) {
        const getCurrentService = () => {
          return servicesData.find((x) => x.id === bookedServiceStatus[1].id)
        }

        setBookableParts(
          await machbarkeitsPruefung(
            selectedParts,
            getCurrentService().essential_attributes,
            getCurrentService().name,
            t,
          ),
        )

        setLoading(false)
      }
    }

    getMachbarkeit()
  }, [servicesData, bookedServiceStatus, selectedParts, setBookableParts, t])

  useEffect(() => {
    setConfigState(!(bookableParts && bookableParts.bookableParts.length === 0))
    if (bookableParts && bookableParts.bookableParts.length === 0) {
      setDefaultActiveKey(['2'])
    } else {
      setDefaultActiveKey(['1'])
    }
  }, [bookableParts])

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img
          src={check_successful}
          alt="check successful"
          width="200px"
          height="200px"
        />
        <div>
          <h2>{t('service.check_successful')}</h2>
          <p>
            {t('service.part_editable', {
              count: bookableParts?.bookableParts?.length,
            })}
          </p>
        </div>
      </div>
      {bookableParts?.notBookableParts?.length !== 0 && bookableParts && (
        <Alert
          message={t('service.removing_alert_message', {
            count1: bookableParts?.notBookableParts?.length,
            count2:
              bookableParts?.notBookableParts?.length +
              bookableParts?.bookableParts?.length,
          })}
          type="error"
        />
      )}
      <StyledCollapse
        accordion
        activeKey={defaultActiveKey}
        onChange={onChange}
        style={{ margin: '22px 0' }}
      >
        <Panel
          header={
            <>
              <CheckCircle />
              {t('service.processable')}
            </>
          }
          key="1"
        >
          <StyledTable
            loading={loading}
            size="middle"
            columns={createColumnsFeasible(t)}
            dataSource={bookableParts?.bookableParts} //feasibleParts()
            rowKey={(part) => part.id}
          />
        </Panel>
        <Panel
          header={
            <>
              <TimesCircle />
              {t('service.processable_after_adjustments')}
            </>
          }
          key="2"
        >
          <StyledTable
            loading={loading}
            size="middle"
            columns={createColumnsNotFeasible(t)}
            dataSource={bookableParts?.notBookableParts} //notFeasibleParts()
            rowKey={(part) => part.id}
          />
        </Panel>
      </StyledCollapse>
    </>
  )
}

StepOneSelection.propTypes = {
  servicesData: PropTypes.array,
  bookedServiceStatus: PropTypes.bool,
  selectedParts: PropTypes.array,
  setBookableParts: PropTypes.func,
  bookableParts: PropTypes.object,
  setConfigState: PropTypes.func,
}

export default StepOneSelection
